<script setup lang="ts">
	import { ref, onBeforeMount, onBeforeUnmount } from "vue"
	import { GoogleAuth } from "@/plugins/GoogleAuth"

	const loading = ref(false)

	const props = defineProps({
		clientId: { type: String, required: true },
	})

	const emit = defineEmits(["success", "error"])

	onBeforeMount(() => {
		GoogleAuth.init({
			clientId: props.clientId,
		})
	})

	onBeforeUnmount(() => GoogleAuth.cleanUp())

	async function signIn() {
		try {
			loading.value = true
			const { accessToken } = await GoogleAuth.signIn()
			// console.log("MY TOKEN", token)
			emit("success", { token: accessToken })
		} catch (e) {
			emit("error", { message: e.message })
		} finally {
			loading.value = false
		}
	}
</script>

<template>
	<button class="google-btn" :disabled="loading" @click="signIn">
		<img
			src="https://developers.google.com/identity/images/g-logo.png"
			alt=""
			class="google-icon" />
		<span v-if="!loading">Continue with Google</span>
		<span v-else class="spinner-border spinner-border-sm" />
	</button>
</template>

<style scoped>
	.google-btn {
		/* layout & spacing (12-10-12 padding on web) */
		display: inline-flex;
		align-items: center;
		gap: 10px; /* space after icon: 10 px  → spec */
		padding: 0 12px 0 12px; /* equal right/left for symmetry */
		min-width: 150px;
		height: 40px; /* web buttons are 40-46 px tall */
		/* brand colors */
		background: #ffffff; /* spec fill colour */
		border: 1px solid #747775; /* spec stroke colour */
		color: #1f1f1f; /* spec font colour */
		border-radius: 4px; /* material/button default, matches examples */
		font: 500 14px/20px Roboto, system-ui, sans-serif; /* spec size/weight */
		cursor: pointer;
		transition: background 0.2s ease, box-shadow 0.2s ease;
	}

	.google-btn:hover:not(:disabled) {
		background: #f6f9fe; /* subtle hover tint: Google outline theme */
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
	}

	.google-btn:active:not(:disabled) {
		background: #eee;
	}

	.google-btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.google-icon {
		width: 18px; /* official sample size */
		height: 18px;
	}
</style>
